export default __webpack_public_path__ + "static/media/109.feb61e4f.svg";